#import "../../list/UserGroupFields.graphql"
mutation UserGroupCreate($input: UserGroupCreateInput!) {
  userGroupCreate(input: $input) {
    userGroup {
      ...UserGroupFields
    }
  }
}
